<template>
  <div></div>
</template>

<script>
import { watch, computed, getCurrentInstance } from 'vue'
import { useDialogsStore } from '@/stores/dialogs'
import { omit } from 'lodash'

export default {
  setup() {
    const dialogsStore = useDialogsStore()
    const instance = getCurrentInstance()

    const queue = computed(() => dialogsStore.queue)
    const active = computed(() => dialogsStore.active)

    watch(queue, (queueItem) => {
      if (queueItem) {
        console.log('config', queueItem.message)
        console.log('active', active.value)

        if (active.value && active.value.priority < queueItem.priority) {
          active.value.inst.close()
        }

        const config = omit(queueItem, ['__type'])

        if (config.onConfirm) config.onConfirm = config.onConfirm.bind(instance)
        if (config.onCancel) config.onCancel = config.onCancel.bind(instance)

        const type = queueItem['__type']
        const inst = (type == 'snackbar')
          ? instance.proxy.$buefy.snackbar.open(config)
          : instance.proxy.$buefy.dialog[queueItem['__type']](config)

        if (type !== 'snackbar') {
          // only set dialogs as active
          dialogsStore.setActive({
            inst, priority: queueItem.priority, uuid: queueItem.uuid
          })
        } else {
          // immediately remove the snackbar from the queue
          config.onConfirm()
        }
      }
    })

    return {}
  }
}
</script>
